import React, {Fragment, PureComponent} from "react";
import {connect} from "react-redux";
import EXIF from "exif-js";
import exif2css from "exif2css";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import styles from "./style.css";
import StickersComponentsScannerHeader from "../../components/scanner-header";
import Icon from "../../../../icons/Icon";
import UQButton from "../../../../uq-ui/components/button";
import {photoDone, setLayoutSize, setOriginPhoto} from "../../../store/media-photo/actions";
import {mediaPhotoStateSelector} from "../../../store/media-photo/selectors";
import {setGoAppModalVisibility} from "../../../../layout/store/actions";
import {StickerCreateStepEnum} from "../../../domain/enums/StickerCreateStepEnum";
import {checkStepValidation} from "../../../store/create-llama/actions";
import Div100vh from "../../../../uq-ui/components/div-100";
import {getSizeContain, isChrome} from "../../../../../infrastructure/helpers";
import {
  createLlamaIdSelector,
  createStickerIdSelector,
  createStickerItemIdSelector
} from "../../../store/create-llama/selectors";
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';

const isChromeBrowser = isChrome();

class StickersScreensNewStickerMediaPhoto extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      exifImageStyles: {opacity: 0}
    };
  }

  componentDidMount() {
    goolgeAnalytics.setCurrentScreen('web-new-sticker-media-photo');
    this._isMounted = true;
    this.props.checkStepValidation(StickerCreateStepEnum.PhotoConfigure);
    const blob = this.props.mediaState.originPhotoInfo.blob;
    this.setupStylesForExifImageTimer = setTimeout(() => {
      if (this._isMounted) this.setupStylesForExifImage(blob);
    }, 50);
  }

  componentWillReceiveProps(nextProps) {
    if (isChromeBrowser && nextProps.mediaState.originPhotoInfo.blob instanceof File) {
      this.setupStylesForExifImage(nextProps.mediaState.originPhotoInfo.blob);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this.setupStylesForExifImageTimer);
  }

  onBackPressed = () => {
    this.props.history.push(`/stickers/${this.props.stickerId}/new`);
  };

  onDonePressed = () => {
    const {activeCanvases, canvasesSchema} = this.state;
    this.props.photoDone({
      activeCanvases,
      canvasesSchema
    });
  };

  setupStylesForExifImage = (blob) => {
    if (blob) {
      EXIF.getData(blob, () => {
        let exifImageStyles = {opacity: 1};
        const orientation = EXIF.getTag(blob, 'Orientation');
        if (orientation === 8 || orientation === 6) {
          // change width and height
          const height = EXIF.getTag(blob, 'PixelXDimension');
          const width = EXIF.getTag(blob, 'PixelYDimension');
          const size = getSizeContain({width, height}, {height: window.innerHeight, width: window.innerWidth});

          const {transformStrings} = exif2css(orientation);
          exifImageStyles = {
            opacity: 1,
            transform: transformStrings.rotate,
            maxWidth: `${size.height}px`
          };
        }

        if (this._isMounted) {
          this.setState({exifImageStyles});
        }
      });
    }
  };

  _renderControls = () => {
    return (
      <div className={styles.doneControls}>
        <UQButton label={this.props.t('doneBtn')}
                  containerStyle={{minWidth: 140}}
                  theme="brand"
                  onPress={this.onDonePressed}/>
      </div>
    );
  };

  _renderImageWithExif() {
    return (
      <Fragment>
        {this.state.exifImageStyles.opacity === 0 && (
          <div className={styles.loader}>{this.props.t('imageLoading')}</div>
        )}
        <img src={this.props.mediaState.originPhotoPath}
             style={this.state.exifImageStyles}
             className={styles.image}/>
      </Fragment>
    );
  }

  _renderImage() {
    if (isChromeBrowser) {
      return this._renderImageWithExif();
    }

    return (<img src={this.props.mediaState.originPhotoPath} className={styles.image}/>);
  }

  render() {
    return (
      <Div100vh className={styles.container}>
        <StickersComponentsScannerHeader
          theme="brand"
          title={this.props.t('headerTitle')}
          showBackBtn={true}
          onBack={this.onBackPressed}/>
        {this._renderImage()}
        <div className={styles.doneControlsContainer}>
          {this._renderControls()}
        </div>
      </Div100vh>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    photoDone: (data) => dispatch(photoDone(data)),
    setOriginPhoto: (photoInfo) => dispatch(setOriginPhoto(photoInfo)),
    setLayoutSize: (size) => dispatch(setLayoutSize(size)),
    showAppModal: () => dispatch(setGoAppModalVisibility(true)),
    checkStepValidation: (stepEnum) => dispatch(checkStepValidation(stepEnum))
  }
};

const mapStateToProps = (state) => {
  return {
    stickerId: createStickerIdSelector(state),
    stickerItemId: createStickerItemIdSelector(state),
    mediaState: mediaPhotoStateSelector(state),
  }
};

export default compose(
  withTranslation('scr-new-sticker-image'),
  connect(mapStateToProps, mapDispatchToProps)
)(StickersScreensNewStickerMediaPhoto);
